import { connect } from 'react-redux';

import RootLoadingSpinnerComponent from '@app/components/Loading/RootLoadingSpinnerComponent';
import { isPasswordReseting } from '@app/store/account/password/selectors';
import { isSendingToEmail } from '@app/store/document/selectors';
import { isRejecting } from '@app/store/documents/selectors';

/**
 * 글로벌 스피너 로딩에 대해서 필요한 경우 selector를 이용해
 * isLoading에 추가하면 글로벌 스피너 로딩이 발생합니다
 * @return
 * isLoading: 글로벌 스피너 로딩이 필요한 여부 (true: Spinner On)
 * isOverlay: 로딩시 배경에 오버레이가 필요한 경우 (true: Overlay On)
 */

const mapStateToProps = (state) => {
  const isRejectDocument = isRejecting(state);
  const isResetPassword = isPasswordReseting(state);
  const isSendingDocumentToEmail = isSendingToEmail(state);

  return {
    isLoading: isRejectDocument || isResetPassword || isSendingDocumentToEmail,
    isOverlay: isRejectDocument || isResetPassword || isSendingDocumentToEmail,
  };
};

export default connect(mapStateToProps)(RootLoadingSpinnerComponent);
